import Vue from "vue";
import Buefy from "buefy";
import CartDetail from "./App.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(CartDetail)

if(document.getElementById("cartDetailApp")){
    new Vue({
        render:h=>h(
            CartDetail,{
                props:{
                    cartDetailUrl:document.getElementById("cartDetailApp")
                        .getAttribute("cartDetailUrl"),
                    checkoutTemplate:document.getElementById("cartDetailApp")
                        .getAttribute("checkoutTemplate")
                }
            }
        )
    }).$mount("#cartDetailApp")
}